@import 'apps/webcomponents/src/assets/style-helpers.scss';
@import 'apps/webcomponents/src/assets/color-helpers.scss';
@import 'apps/webcomponents/src/assets/text-helpers.scss';
@import 'apps/webcomponents/src/assets/common.scss';

.wrapper {
  flex-direction: column;
  height: 100%;
}

.content {
  flex-grow: 2;
  height: 100%;

  .grid {
    height: 100%;
  }

  .grid-view {
    min-height: 100%;
    align-items: stretch;
  }

  .header-buttons {
    margin-right: calc(2 * var(--spacer));
    position: relative;

    .inline-block {
      display: inline-block;
    }

    .action-button-text,
    .action-icon {
      vertical-align: middle;
    }

    .action-icon {
      display: inline-block;

      &:before {
        font-size: 32px;
      }
    }

    gz-button[class='action-button']::part(button) {
      padding-right: var(--spacer);
    }
  }
}
